export enum ComponentType {
  CommonComponent = "CommonComponent",
  WebServiceComponent = "WebServiceComponent",
}
